"use client";

import { useEffect, useState } from "react";
import PricingCard from "./PricingCard";
import { pricingData } from "@/data/pricingData";
import { imageMap } from "@/assets/imageMap";
import { isRegistrationClosed } from "@/config/registration";

export default function RegistrationPricing() {
    const [isClosed, setIsClosed] = useState(false);

    useEffect(() => {
        setIsClosed(isRegistrationClosed());
    }, []);

    return (
        <div className="grid md:grid-cols-3 gap-8 items-start">
            {pricingData.map((item, idx) => (
                <PricingCard
                    key={item.id}
                    title={item.title}
                    price={item.price}
                    description={item.content}
                    imageSrc={imageMap[item.imageKey] ?? imageMap["inscripcion-hero"]}
                    icon={item.icon}
                    recommended={idx === 1}
                    ctaHref={item.ctas[0]?.href ?? "#"}
                    ctaLabel={item.ctas[0]?.label ?? "Inscripción"}
                    soldOut={item.soldOut}
                    isClosed={isClosed}
                    isTemporarilyClosed={item.isTemporarilyClosed}
                    note={item.note}
                />
            ))}
        </div>
    );
}
